import { createApi } from '@reduxjs/toolkit/query/react';

import { ITariff } from '../store/tariff.slice';

import { baseQueryWithReauth } from './api';

export type TariffsResponse = { tariffs: ITariff[]; maxToolsCount: number };

export const tariffApi = createApi({
  reducerPath: 'tariff',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['tariff'],
  endpoints: (build) => ({
    getActiveTariffs: build.query<ITariff[], void>({
      query: () => ({
        url: '/me/plans/active',
      }),
    }),
    getScheduledTariffs: build.query<ITariff[], void>({
      query: () => ({
        url: '/me/plans/scheduled',
      }),
    }),
    getTariffs: build.query<TariffsResponse, void>({
      query: () => ({
        url: '/plans',
      }),
      transformResponse: (rawTariffs: ITariff[]): TariffsResponse => {
        const maxTools = rawTariffs.length
          ? Math.max(
              ...rawTariffs.map((e) => {
                if (Array.isArray(e.tools_data) && e.tools_data.length) {
                  return e.tools_data.length;
                }

                return Array.isArray(e.tool_names) ? e.tool_names.length : 0;
              }),
            )
          : 0;

        return {
          tariffs: rawTariffs.map((r) => {
            if (typeof r.duration_days !== 'string' && r.duration_days < 0) r.duration_days = 'unlimit';
            r.tools_data = Array.isArray(r.tools_data) ? r.tools_data : [];

            return r;
          }),
          maxToolsCount: maxTools,
        } as TariffsResponse;
      },
    }),
  }),
});

export const { useLazyGetTariffsQuery, useLazyGetActiveTariffsQuery, useLazyGetScheduledTariffsQuery } = tariffApi;
